<div *ngIf="size == 1">
  <div class="card margin-b">
    <div class="card-body border-r">
      <!-- [style.background-color]="color"> -->
      <div class="display">
        <div class="image-wrapper">
          <img [src]="profilePicture" (error)="getErrorImage($event)" />
        </div>
        <!-- <div class="text-area">
          <div>
            <h5 class="card-title color ">{{data.type}}</h5>
          </div>
          <div>
            <h5 class="card-title">{{data.name}}</h5>
          </div>
          <div class="time-text">
            <span class="margin-l">
              <p>{{data?.link }}</p>
            </span>

          </div>

        </div> -->
        <div class="text-area-small" >
          <div style="margin-bottom: 5px; font-weight: 600; color: #176663">
            {{ data?.type }}
          </div>
          <div
            class="flag"
            style="width: 20px; position: absolute; right: 2%; top: 5%"
          >
            <span class="notification-flag"
            [ngStyle]="{
              'background-color': data?.type === 'Important Update' ? 'green' :
                                 data?.type === 'Emergency Update' ? 'red' :
                                 data?.type === 'General Message' ? 'rgb(255, 230, 8)' : 'transparent'
            }"
            ></span>
          </div>
          <div>{{ data?.name }}</div>
          <div>
            <p class="card-text">{{ data?.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="size == 0">
  <div class="card margin-b">
    <div class="card-body border-r">
      <div class="display">
        <div class="image-wrapper">
          <img
            [src]="renderImage(data.createdBy.user.photo)"
            (error)="getErrorImage($event)"
          />
        </div>
        <div class="text-area-small">
          <div class="display" style="justify-content: space-between">
            <h5 class="card-title">{{ data?.name | titlecase }}</h5>
          </div>

          <div class="time-text" style="width: 400px">
            <div>
              <p>{{ data?.description }}</p>
            </div>
          </div>

          <div *ngIf="showtext === true" class="display">
            <p>Added by:</p>
            <p style="color: #676767; margin-left: 5px">
              {{ data?.createdBy?.user?.name | titlecase }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="size == 2">
  <div class="card margin-b">
    <div class="card-body border-r cursor">
      <div class="display">
        <div class="image-wrapper">
          <img
            [src]="renderImage(data?.photo)"
            (error)="getErrorImage($event)"
          />
        </div>
        <div
          [routerLink]="route"
          *ngIf="data?.type == 'notification'"
          class="text-area-small"
        >
          <div>
            <p>{{ data?.createdAt | date : "medium" }}</p>
            <p>{{ data?.description }}</p>
          </div>
        </div>

        <div
          *ngIf="data?.type != 'notification'"
          class="text-area-small clickAble"
        >
          <div class="display relative" style="justify-content: space-between">
            <h5
              class="card-title d-flex justify-content-between w-100"
              [ngClass]="{ 'title-color': addedBy }"
              (click)="navigate($event)"
            >
              {{ data?.name | titlecase }}
              <span class="position-relative star" *ngIf="data.isFounder">
                <i class="fas fa-star"></i> <span class="char">F</span>
              </span>
            </h5>
            <button
              *ngIf="others"
              type="button"
              style="background: #FFDF00; color: #000;"
              class="btn btn-sm main-backgroundcolor"
              (click)="navigateCliam()"
            >
              {{ title }}
            </button>
            <div *ngIf="sideButton" class="sideButton">
              <div *ngIf="data?.parentType != 'partners'" class="dropdown">
                <button
                  class="btn btn1 dropdown-toggle"
                  type="button"
                  (click)="openDropdown($event)"
                  aria-haspopup="true"
                  aria-expanded="false"
                ></button>
                <div class="dropdown-menu" *ngIf="isDropdown">
                  <a
                    *ngIf="data?.reported != 'No'"
                    class="dropdown-item cursor"
                    (click)="getReportId(data.id)"
                    >Report</a
                  >
                  <a
                    *ngIf="data?.type != 'Blocked'"
                    class="dropdown-item cursor"
                    (click)="getBlockId(data.id)"
                    >Block</a
                  >
                  <a
                    *ngIf="data?.type == 'Blocked'"
                    class="dropdown-item cursor"
                    (click)="getUnblockId(data.id)"
                    >Unblock</a
                  >
                  <a
                    *ngIf="
                      data?.type == 'user' || data.parentType == 'followers'
                    "
                    (click)="open(mymodal, 'community')"
                    class="dropdown-item cursor"
                    >Add as staff</a
                  >
                </div>
              </div>
            </div>
          </div>

          <div class="time-text">
            <div>
              <p>{{ data?.description }}</p>

              <p>{{ data?.email }}</p>
            </div>
          </div>

          <div>
            <p
              *ngIf="!others"
              style="color: #676767; margin-left: 5px; float: right"
            >
              {{ data?.createdAt }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #mymodal let-modal>
  <div class="modal-header main-backgroundcolor">
    <h4 class="modal-title color" id="modal-basic-title">Staff List</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true" class="color">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div *ngIf="loading == false">
      <app-card-skelton *ngFor="let props of arr"></app-card-skelton>
    </div>

    <div *ngIf="loading">
      <div
        class="card margin-b"
        *ngFor="let props of loadMoreArr; let i = index"
      >
        <div class="card-body border-r">
          <div class="display">
            <!-- <div class="image-wrapper">
            </div> -->
            <div class="text-area display justify-content">
              <div>
                <h5 class="card-title"></h5>
                <p>{{ props.name }}</p>
              </div>
              <div class="form-check-input-inner">
                <input
                  type="checkbox"
                  [value]="props.name"
                  (change)="selectItem($event, props)"
                  class="form-check-input"
                  id="exampleCheck1"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <h6 *ngIf="showError" class="error">{{ modalError }}</h6>

      <div *ngIf="showButton" style="text-align: center">
        <button
          type="button"
          class="btn color main-backgroundcolor btn-sm pull-right"
          (click)="showMore()"
        >
          Show more
        </button>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <!-- <button *ngIf="!staticButton" type="button" class="btn color main-backgroundcolor btn-sm pull-right"
      (click)="modal.close('Save click')">
      Select</button> -->

    <button
      type="button"
      class="btn color main-backgroundcolor btn-sm pull-right"
      (click)="select(); modal.close('Save click')"
    >
      Select
    </button>
  </div>
</ng-template>
